import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/domains';
import { FORM_RELEASE_REPOSITORY, FORM_RELEASE_CACHED_REPOSITORY } from '../../core';
import { FORM_RELEASE_API } from '../data-sources';
import { FormReleaseMapper } from './form-release.mapper';
export var FormReleaseWebRepository = /*#__PURE__*/function () {
  function FormReleaseWebRepository(formReleaseApi, formReleaseCachedRepository, mapper) {
    _classCallCheck(this, FormReleaseWebRepository);

    this.formReleaseApi = formReleaseApi;
    this.formReleaseCachedRepository = formReleaseCachedRepository;
    this.mapper = mapper;
  }

  _createClass(FormReleaseWebRepository, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var responseOrError, createdFormReleaseResponse, mappedDomainOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.formReleaseApi.create(input);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                createdFormReleaseResponse = responseOrError.getValue();
                mappedDomainOrError = this.mapper.toDomain(createdFormReleaseResponse);

                if (!mappedDomainOrError.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", Result.fail(mappedDomainOrError.error));

              case 9:
                return _context.abrupt("return", Result.ok(mappedDomainOrError.getValue()));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "findFormReleaseById",
    value: function () {
      var _findFormReleaseById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var cachedFormReleaseResult, responseOrError, formReleaseResponse;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.formReleaseCachedRepository.has(id)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return this.formReleaseCachedRepository.findById(id);

              case 3:
                cachedFormReleaseResult = _context2.sent;

                if (!cachedFormReleaseResult.isSuccess) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", Result.ok(cachedFormReleaseResult.getValue()));

              case 6:
                _context2.next = 8;
                return this.formReleaseApi.findFormReleaseById(id);

              case 8:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 11:
                formReleaseResponse = responseOrError.getValue();
                formReleaseResponse.sections.sort(function (a, b) {
                  return a.index - b.index;
                });
                this.formReleaseCachedRepository.create(formReleaseResponse);
                return _context2.abrupt("return", Result.ok(formReleaseResponse));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function findFormReleaseById(_x2) {
        return _findFormReleaseById.apply(this, arguments);
      }

      return findFormReleaseById;
    }()
  }]);

  return FormReleaseWebRepository;
}();
export var formReleaseWebRepositoryProvider = {
  provide: FORM_RELEASE_REPOSITORY,
  useFactory: function useFactory(formReleaseApi, formReleaseCachedRepository, mapper) {
    return new FormReleaseWebRepository(formReleaseApi, formReleaseCachedRepository, mapper);
  },
  inject: [FORM_RELEASE_API, FORM_RELEASE_CACHED_REPOSITORY, FormReleaseMapper]
};